import {
  EMPTY_STATES,
    FETCH_STATES_SUCCESS,
  } from "../ActionTypes";
  
  const INIT_STATE = {
    statesfetched: [],
    };
  
  function reducers(state = INIT_STATE, action) {
    switch (action.type) {
      case FETCH_STATES_SUCCESS: {
        return {
          ...state,
          statesfetched: action.payload,
        };
      }
      case EMPTY_STATES: {
        return {
          ...state,
          statesfetched: [],
        };
      }
      default:
        return state;
    }
  }
  
  export default reducers;
  